export default {
    name: 'breadcrumb',
    computed: {
        breadcrumbs(){
            return this.$store.state.breadcrumbs;
        },
        redirect(){
            return this.$store.state.redirect;
        },
    },
    render(h){
        var dom = this.breadcrumbs.map((item, index) => {
            if(item.path){
                // let url = (item.path.slice(0, 1) == '/' ? '' : '/') + item.path + this.redirect;
                let url = item.path;
                return (
                    <li class="breadcrumb-item"><a class="text-decoration-none" href={url}>{item.title}</a></li>
                );
            }
            return (
                <li class="breadcrumb-item active">{item.title}</li>
            );
        });
        return (
            <nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
                <ol class="breadcrumb mb-0">
                    {dom}
                </ol>
            </nav>
        );
    }
}
